import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StevensTopbar } from '@/components/landing/StevensTopbar';
import { StevensFooter } from '@/components/landing/StevensFooter';
import { api } from '@/services/api';
import type { LegalDocMeta } from '@/services/api';
import '../landing-v2.css';

const DOC_TO_SLUG: Record<string, string> = {
  tos: 'terms', privacy: 'privacy', ai_notice: 'ai', crisis: 'safety',
  sms: 'sms', email_marketing: 'email', helper_code: 'helper-code', trfer_aup: 'trfer-aup',
  community_disclosure: 'community-disclosure',
  phi_authorization: 'phi-authorization', publicity_release: 'publicity-release',
  data_sharing_website: 'data-sharing-website', data_sharing_social_media: 'data-sharing-social-media',
  data_sharing_newsletter: 'data-sharing-newsletter', data_sharing_donor: 'data-sharing-donor',
  data_sharing_grant_writing: 'data-sharing-grant-writing',
};

export function LegalIndexPage() {
  const { t } = useTranslation('legal');
  const [docs, setDocs] = useState<LegalDocMeta[]>([]);
  useEffect(() => {
    api.legal.index()
      .then((r) => setDocs(r.status === 'success' && r.data ? r.data : []))
      .catch(() => setDocs([]));
  }, []);
  return (
    <div className="landing-page">
      <StevensTopbar />
      <main className="wrap legal-shell">
        <h1>{t('index.title')}</h1>
        <ul className="legal-index">
          {docs.map((d) => (
            <li key={d.document_id}>
              {/* Titles are server data and stay English (#2109 R3-B9). */}
              <Link lang="en" to={`/legal/${DOC_TO_SLUG[d.document_id] ?? d.document_id}`}>{d.title}</Link>
              <span className="legal-index__v">{t('index.version', { version: d.version })}</span>
            </li>
          ))}
        </ul>
      </main>
      <StevensFooter />
    </div>
  );
}
